const ObjetoImpDR = [
  {
    label:'Selecciona',
    value: ''
  },
  {
    label:'No objeto de impuesto. (01)',
    value: '01'
  },
  {
    label:'Sí objeto de impuesto. (02)',
    value: '02'
  }
];

export default ObjetoImpDR;